import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BaseHandler, copyToNewQueryOperation } from '../../graphql-orchestrator-link';
import { GetMarketplaceSearch, SearchResultHandler } from '../SearchResult';
export class PartnerProfileHandler extends BaseHandler {
  constructor(algoliaConfig) {
    super();
    _defineProperty(this, "algoliaConfig", void 0);
    _defineProperty(this, "searchResultHandler", void 0);
    this.algoliaConfig = algoliaConfig;
    this.searchResultHandler = new SearchResultHandler(this.algoliaConfig);
  }
  async fetchCustom(operation, transformedOperation, sequenceConfigValue, primaryResponse) {
    const searchOperation = copyToNewQueryOperation(operation, GetMarketplaceSearch, _ref => {
      let {
        after,
        first
      } = _ref;
      return {
        query: '',
        filters: {},
        sort: '',
        algoliaSearchIndex: this.algoliaConfig.algoliaSearchIndex,
        additionalFilters: {
          vendorId: operation.variables.vendorId
        },
        after,
        first
      };
    });
    const response = await this.searchResultHandler.fetchCustom(searchOperation, transformedOperation, sequenceConfigValue, primaryResponse);
    return response;
  }
  responseTransformer(operation, transformedOperation, sequenceConfigValue, _primaryResponse, customResponse) {
    const newResponse = this.searchResultHandler.responseTransformer(operation, transformedOperation, sequenceConfigValue, undefined, customResponse);
    return {
      marketplacePartnerProfile: {
        __typename: 'MarketplacePartnerProfile',
        apps: (newResponse === null || newResponse === void 0 ? void 0 : newResponse.marketplaceSearch) || null
      }
    };
  }
}